import * as React from "react";
import UserCenter from "./UserCenter";

// Icons
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCaretRight, faCaretLeft } from '@fortawesome/free-solid-svg-icons'
library.add(faCaretRight, faCaretLeft)

interface ISideBar { }
class SideBar extends React.Component<ISideBar, any> {
    constructor(props: ISideBar) {
        super(props);
        this.state = {
            isOpen: false
        }
    }

    onToggleOpenSideBar = () => {
        this.setState({
            isOpen: !this.state.isOpen
        })
    }

    render() {
        return (
            <div className={`SideBar ${this.state.isOpen ? "SideBar--collapse" : ""}`}>
                <UserCenter />
                <button className="SideBar__btn--toggle" onClick={this.onToggleOpenSideBar}>
                    {
                        this.state.isOpen ?
                            <FontAwesomeIcon icon="caret-right" />
                            :
                            <FontAwesomeIcon icon="caret-left" />
                    }
                </button>
            </div>
        )
    }
}

export default SideBar;


// WEBPACK FOOTER //
// ./src/components/sidebar/SideBar.tsx